module.exports = __webpack_public_path__ + "static/salon-bdc6d9af291d5440b1cd0a8bb4c1ee06.png";